/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-08-17 15:12:57
 * @LastEditors: TangXihao
 * @LastEditTime: 2020-12-21 14:34:39
 */

import React, { } from 'react'
import { Col, Row, Breadcrumb, Divider, Avatar, Input } from 'antd';
import { Link } from 'react-router-dom';
import './index.css'
import Qimage from '../../../statics/Q.png'
import Aimage from '../../../statics/A.png'
import tx from '../../../statics/friend_isClick.png'

class QAAsk extends React.Component {
    render() {
        return (<Col span={24} className='QAnew' >
            <Row gutter={0} style={{ background: 'rgba(235, 238, 241, 1)' }}>
                {/* <Col span={3} /> */}
                <div span={18} className='WD-Alist-panel'>
                    <Breadcrumb className='WD-bc'>
                        <Breadcrumb.Item>
                            <Link to='/Q&ACenter'>问答中心</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item style={{ color: 'rgba(89, 89, 89, 1)' }}>
                            新的提问
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <Divider className="WD-Adivider" ></Divider>
                    <Col span={24} className='WD-A-A' >
                        <Row>
                            <Col span={1}></Col>
                            <Col span={22}>
                                <Row style={{ height: 58 }}>

                                    <Col span={2}>
                                        <img alt="问" src={Qimage} style={{ height: 36, width: 36, marginBottom: 10, marginTop: 12 }}></img>
                                    </Col>
                                    <Col span={14} >
                                        <Row>
                                            <Col span={16} className='WDlistQ'>
                                                <Input></Input>
                                            </Col>


                                        </Row>
                                    </Col>
                                    <Col span={8} className='WDinfo2'>


                                    </Col>
                                </Row>
                                <Divider className="WD-A-Adivider" />


                            </Col>
                            <Col span={1}></Col>
                        </Row>

                    </Col>

                    <Row style={{ height: 20 }} />

                </div>

                {/* <Col span={3} /> */}
            </Row>
        </Col>)

    }
}
export default QAAsk